// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=44-965
// Types: primary (black fill) | secondary (outlined) | tertiary (gray fill)
// States: active | disabled | pressed | loading

import classnames from 'classnames'
import { BACK_ARROW_SVG } from '~/lib/buttonSvgs'
import Spinner from '~/components/ui/Spinner'

export default function DefautButton({ title, isPrimary, isLoading, isBack, disabled, onClick, tabIndex, className }) {
  return (
    <button
      key={title}
      type="button"
      tabIndex={tabIndex !== undefined ? tabIndex : 0}
      onClick={onClick}
      disabled={disabled}
      className={classnames(
        // Non-conflicting base
        'relative h-12 w-full px-4 rounded-button border-solid',
        'text-[17px] font-bold uppercase tracking-[0.68px] leading-5',
        'transition-colors duration-200',
        'disabled:cursor-default disabled:pointer-events-none disabled:border-on-surface/[0.12] disabled:text-on-surface/[0.38]',

        // Mutually exclusive bg/text/border — no conflicts
        isBack
          ? 'shrink-0 !w-12 bg-white border border-primary bg-no-repeat bg-center text-transparent'
          : isPrimary
            ? [
                'border border-primary bg-primary text-on-primary',
                'hover:bg-primary/90 focus-visible:bg-primary/90',
                'disabled:bg-surface-container-highest',
              ]
            : [
                'border-[1.5px] border-primary bg-white text-primary',
                'hover:bg-black/[0.04] focus-visible:bg-black/[0.12]',
              ],

        // Loading — hide text
        isLoading && 'cursor-default !text-transparent select-none',

        className,
      )}
      style={isBack ? { backgroundImage: BACK_ARROW_SVG } : undefined}
    >
      {isLoading && (
        <span className="absolute inset-0 flex items-center justify-center">
          <Spinner size={16} />
        </span>
      )}
      <span dangerouslySetInnerHTML={{ __html: title }} />
    </button>
  )
}
